import { ApiSchemas } from '@/components/providers/v1-api';

type EnumObject<T extends string> = Record<T, string>;

function createEnumOptions<T extends string>(enumObject: EnumObject<T>): { value: T; label: string }[] {
  return Object.entries(enumObject).map(([value, label]) => ({ value: value as T, label: label as string }));
}

type EmployeeRole = ApiSchemas['EmployeeRole'];

export const EMPLOYEE_ROLES_MAP: Record<EmployeeRole, string> = {
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  TECHNICIAN: 'Technician',
  STAFF: 'Staff',
  SALES: 'Sales',
};

export const EMPLOYEE_ROLES = createEnumOptions(EMPLOYEE_ROLES_MAP);

type EmployeeStatus = ApiSchemas['EmployeeStatus'];

export const EMPLOYEE_STATUS_MAP: Record<EmployeeStatus, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const EMPLOYEE_STATUS = createEnumOptions(EMPLOYEE_STATUS_MAP);

type ApiIssue = ApiSchemas['IssueRead'];

export const ISSUE_CATEGORY_MAP: Record<ApiIssue['category'], string> = {
  INSECT: 'Insect',
  BIRD: 'Bird',
  RODENT: 'Rodent',
  WILDLIFE: 'Wildlife',
  ARACHNID: 'Arachnid',
  OTHER: 'Other',
};

export const ISSUE_CATEGORY_OPTIONS = createEnumOptions(ISSUE_CATEGORY_MAP);

// Skill enums - using actual API schemas
export type SkillCategory = ApiSchemas['SkillCategory'];
export type SkillAction = ApiSchemas['SkillAction'];

export const SKILL_CATEGORY_MAP: Record<SkillCategory, string> = {
  PEST_CONTROL: 'Pest Control',
  SAFETY: 'Safety',
  EQUIPMENT: 'Equipment',
  CUSTOMER_SERVICE: 'Customer Service',
  OTHER: 'Other',
};

export const SKILL_CATEGORY = createEnumOptions(SKILL_CATEGORY_MAP);

export const SKILL_ACTION_MAP: Record<SkillAction, string> = {
  INSPECTION: 'Inspection',
  MONITORING: 'Monitoring',
  BAITING: 'Baiting',
  TRAPPING: 'Trapping',
  CHEMICAL_TREATMENT: 'Chemical Treatment',
  EXCLUSION: 'Exclusion',
  SANITATION: 'Sanitation',
  NEST_REMOVAL: 'Nest Removal',
  FUMIGATION: 'Fumigation',
};

export const SKILL_ACTION = createEnumOptions(SKILL_ACTION_MAP);

type IssueCoverage = ApiSchemas['IssueCoverage'];

export const ISSUE_COVERAGE_MAP: Record<IssueCoverage, string> = {
  NONE: 'None',
  ANY: 'Any',
  INDOOR: 'Indoor',
  OUTDOOR: 'Outdoor',
};

export const ISSUE_COVERAGE_OPTIONS = createEnumOptions(ISSUE_COVERAGE_MAP);
